/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_Run_ButtonInputs */

const en_spellcheck_run_button = /** @type {(inputs: Spellcheck_Run_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run`)
};

const fr_spellcheck_run_button = /** @type {(inputs: Spellcheck_Run_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lancer`)
};

const de_spellcheck_run_button = /** @type {(inputs: Spellcheck_Run_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laufen`)
};

const it_spellcheck_run_button = /** @type {(inputs: Spellcheck_Run_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correre`)
};

const ru_spellcheck_run_button = /** @type {(inputs: Spellcheck_Run_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бегать`)
};

const es_spellcheck_run_button = /** @type {(inputs: Spellcheck_Run_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correr`)
};

const zh_cn2_spellcheck_run_button = /** @type {(inputs: Spellcheck_Run_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`跑步`)
};

const ja_spellcheck_run_button = /** @type {(inputs: Spellcheck_Run_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`走る`)
};

const hi_spellcheck_run_button = /** @type {(inputs: Spellcheck_Run_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दौड़ना`)
};

const pt_pt2_spellcheck_run_button = /** @type {(inputs: Spellcheck_Run_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correr`)
};

/**
* | output |
* | --- |
* | "Run" |
*
* @param {Spellcheck_Run_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_run_button = /** @type {((inputs?: Spellcheck_Run_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Run_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_spellcheck_run_button(inputs)
	if (locale === "de") return de_spellcheck_run_button(inputs)
	if (locale === "it") return it_spellcheck_run_button(inputs)
	if (locale === "ru") return ru_spellcheck_run_button(inputs)
	if (locale === "es") return es_spellcheck_run_button(inputs)
	if (locale === "zh-CN") return zh_cn2_spellcheck_run_button(inputs)
	if (locale === "ja") return ja_spellcheck_run_button(inputs)
	if (locale === "hi") return hi_spellcheck_run_button(inputs)
	if (locale === "pt-PT") return pt_pt2_spellcheck_run_button(inputs)
	return en_spellcheck_run_button(inputs)
});